<template>
  <footer class="footer">
    <div class="footer__success" v-if="step_1_status===3&&step_2_status===3">
      <div class="footer__success-title">Thank you for signing up for eBlitz!</div>
      <div class="footer__success-subtitle" >Please, <a class="footer__success-link" href="https://licenses708266.typeform.com/to/QDwvK7RX">complete this quick survey</a>
        to help us improve your gaming experience
        on the app. Thanks for your support!
      </div>
    </div>
    <div class="footer__logo">
      <img src="../assets/logo-bottom.png">
    </div>
    <div class="footer__copyright">
      <div class="footer__copyright-text">© 2021 eBlitz. All Rights Reserved. Questions to feedback@eblitz.gg</div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    step_1_status() {
      return this.$store.getters.step_1_status
    },
    step_2_status() {
      return this.$store.getters.step_2_status
    },
    /*step_3_status() {
      return this.$store.getters.step_3_status
    },
    step_4_status() {
      return this.$store.getters.step_4_status
    },*/
  },
}
</script>

<style scoped>
.footer__success {
  color: #fff;
  text-align: center;

  max-width: 36rem;

  margin: 0 auto 4.5rem;
}

.footer__success-link {
  color: #FFD500;

  transition: color .1s linear;
}
.footer__success-link:hover {
  color: rgba(255,213,0,0.8);
}

.footer__success-title {
  font-size: 2.5rem;
}

.footer__success-subtitle {
  font-size: 1.5rem;
}

.footer__logo {
  display: flex;
  justify-content: center;

  margin-bottom: 1.75rem;
}

.footer__copyright {
  display: flex;
  justify-content: center;

  margin-bottom: 2rem;
}

.footer__copyright-text {
  text-align: center;

  width: 15.35rem;

  color: #999999;
}
</style>